import React from 'react';
import Slider from 'react-slick';
import { SliderContent } from '../helpers/sliderContent';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getBanners } from '../../models/banners';
import i18n from '../../i18n';
import { BannerSkeleton } from '../common/skelton/BannerSkelton';

const settings = {
  arrows: false,
  dots: false,
  infinite: true,
  speed: 1500,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  accessibility: true,
  autoplay: true,
  centerPadding: '0px',
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 1, infinite: true } },
    { breakpoint: 600, settings: { slidesToShow: 1, infinite: true } },
    { breakpoint: 480, settings: { slidesToShow: 1, infinite: true } },
  ],
};

export class HomeBanner extends React.Component {
  constructor() {
    super();
    this.state = {
      is_more_help: false,
      limit: 10,
      banners: [],
      is_loading: false,
    };
    this._isMounted = false; // 👈 track mount state
    this.loadBanners = this.loadBanners.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadBanners();
  }

  componentWillUnmount() {
    this._isMounted = false; // 👈 prevent setState after unmount
  }

  async loadBanners() {
    this.setState({ is_loading: true });
    try {
      const response = await getBanners();
      if (response && this._isMounted) {
        // 👈 check before setState
        this.setState({ banners: response.data, is_loading: false });
      }
    } catch (error) {
      if (this._isMounted) this.setState({ is_loading: false });
      console.error('Error loading banners:', error);
    }
  }

  render() {
    const { banners, is_loading } = this.state;

    return (
      <div
        className="carousel slide position-relative"
        data-bs-ride="carousel"
        id="carouselExampleAutoplaying"
      >
        {is_loading ? (
          <BannerSkeleton />
        ) : (
          <Slider {...settings}>
            {banners.map((x, i) => (
              <SliderContent
                key={i}
                title={x.title}
                title_ar={'مولدات الديزل'}
                amount={18000 + i}
                auctionId={i + 1}
                index={i}
                img={x.banner}
                isAuction={x.isAuction}
                show_store_buttos={x.show_store_buttos}
              />
            ))}
          </Slider>
        )}

        {/* Support Button */}
        <div className="support-button">
          <button
            className="btn btn-primary"
            onClick={() => {
              this.setState({ showPopup: !this.state.showPopup });
              this.props.callbackForSupport?.(true);
            }}
          >
            <img
              src={
                process.env.PUBLIC_URL + '/assets/images/material-symbols_support-agent-sharp.png'
              }
              alt="Support"
            />
            <span className="ms-1">{i18n.t('support')}</span>
          </button>
        </div>
      </div>
    );
  }
}
